// extracted by mini-css-extract-plugin
export var growableInput = "_6w-0";
export var tagContainer = "_6w-2";
export var textInput = "_6w-1";